import React from "react";
// also exported from '@storybook/react' if you can deal with breaking changes in 6.1
import { FormConfiguration } from "../../FormConfiguration";
import { FormRuntime } from "../../FormRuntime";
import { ListEntryFormControl, ListEntryType } from "../Web/ListEntryFormControl";
import { XColumnContainer, XColumnContainerColumn } from "../../Containers";
import { LabelFormControl } from "../Web/LabelFormControl";
import { ExecutionData } from "../../../rule-engine-core/Common/Data/ExecutionData/ExecutionData";
import { StoryNode } from "../../../CommonUI/StoryBook/StoryData";

function getUI(): { form: FormConfiguration } {
    let ui = new FormConfiguration();
    let container = new XColumnContainer();
    let col = new XColumnContainerColumn();

    container.add(col);
    ui.add(container);

    let label = new LabelFormControl();
    label.text = "List Entry";
    col.add(label);

    let textField = new ListEntryFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "value";
    textField.requiredOnAllOutcomes = false;
    col.add(textField);

    textField = new ListEntryFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "value";

    textField.requiredOnAllOutcomes = false;
    textField.mode = ListEntryType.LIST;
    col.add(textField);

    textField = new ListEntryFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "value";
    textField.requiredOnAllOutcomes = false;
    textField.mode = ListEntryType.TEXT;
    col.add(textField);

    textField = new ListEntryFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "value";

    textField.requiredOnAllOutcomes = true;
    textField.mode = ListEntryType.LIST;
    col.add(textField);

    textField = new ListEntryFormControl();
    textField.label = "Text Field Label";
    textField.valueName = "value";

    textField.requiredOnAllOutcomes = true;
    textField.mode = ListEntryType.TEXT;
    col.add(textField);

    return { form: ui };
}

export const ListEntryStories = [
    new StoryNode(
        () => {
            let ui = getUI();
            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "List Entry",
        "Default",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as ListEntryFormControl;
                if (ctf) {
                    ctf.mode = "TEXT" as ListEntryType;
                }
            }

            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "List Entry",
        "With Text Type",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as ListEntryFormControl;
                if (ctf) {
                    ctf.mode = "LIST" as ListEntryType;
                }
            }

            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "List Entry",
        "With List Type",
    ),

    new StoryNode(
        () => {
            let ui = getUI();
            let controls = ui.form.getAllControls();

            for (let c of controls) {
                let ctf = c as ListEntryFormControl;
                if (ctf) {
                    ctf.requiredOnAllOutcomes = true;
                }
            }

            return <FormRuntime form={ui.form}></FormRuntime>;
        },

        "Form Builder",
        "Controls",
        "List Entry",
        "With Validation Breaks",
    ),

    new StoryNode(
        () => {
            let ui = getUI();

            let data = new ExecutionData();
            data.values["value"] = ["Upwork", "HubStaff"];

            return (
                <FormRuntime
                    form={ui.form}
                    formData={data}
                ></FormRuntime>
            );
        },

        "Form Builder",
        "Controls",
        "List Entry",
        "With Value",
    ),
];
